import axios from "axios";

const configHeaders = {
  headers: {
    Authorization: "Bearer " + "yourJWTToken",
  },
};

const connectApi = async ({ method = "GET", url, payload }) => {
  return await axios({
    method,
    url,
    data: payload,
    headers: configHeaders,
    responseType: "json",
  });
};

///////
const baseURL = {
  submitForm: "/campaign_form_api/api/S25Live2025/PostForm",
  checkCloseDate: "/campaign_form_api/api/S25Live2025/CheckCloseDate",
  checkEmailExist: "/campaign_form_api/api/S25Live2025/CheckEmailExist",
  checkPhoneExist: "/campaign_form_api/api/S25Live2025/CheckPhoneExist",
  checkStaffPassword: "/campaign_form_api/api/S25Live2025/CheckStaffPassword",
  getAttendantInfo: "/campaign_form_api/api/S25Live2025/GetAttendantInfo",
  attendantCheckIn: "/campaign_form_api/api/S25Live2025/AttendantCheckIn",
};

export const submitForm = async (payload) => {
  const config = {
    method: "POST",
    url: baseURL.submitForm,
    payload,
  };
  return await connectApi(config);
};

export const checkCloseDate = async ({ code = "" }) => {
  const config = {
    method: "GET",
    url: baseURL.checkCloseDate + `?Code=${code}`,
  };
  return await connectApi(config);
};

export const checkEmailExist = async ({ email = "" }) => {
  const config = {
    method: "GET",
    url: baseURL.checkEmailExist + `?email=${email}`,
  };
  return await connectApi(config);
};

export const checkPhoneExist = async ({ phone = "" }) => {
  const config = {
    method: "GET",
    url: baseURL.checkPhoneExist + `?phone=${phone}`,
  };
  return await connectApi(config);
};

export const checkStaffPassword = async ({ password = "" }) => {
  const config = {
    method: "GET",
    url: baseURL.checkStaffPassword + `?password=${password}`,
  };

  return await connectApi(config);
};

export const getAttendantInfo = async ({ phone = "" }) => {
  const config = {
    method: "GET",
    url: baseURL.getAttendantInfo + `?phone=${phone}`,
  };
  return await connectApi(config);
};

export const attendantCheckIn = async ({ phone = "" }) => {
  const config = {
    method: "GET",
    url: baseURL.attendantCheckIn + `?phone=${phone}`,
  };
  return await connectApi(config);
};
